import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    position: null,
    status: "waiting",
    bypass: null,
    time_left: null,
};
const waitingQueueSlice = createSlice({
    name: "waitingQueue",
    initialState,
    reducers: {
        updateWaitingQueue: (state, action) => {
            if (action.payload.status != undefined)
                state.status = action.payload.status;
            if (action.payload.position != undefined)
                state.position = action.payload.position;
            if (action.payload.time_left != undefined)
                state.time_left = action.payload.time_left;
        },
        updateWaitinghQueueBypass: (state, action) => {
            state.bypass = action.payload;
        },
    },
});
export const { updateWaitingQueue, updateWaitinghQueueBypass } = waitingQueueSlice.actions;
export default waitingQueueSlice.reducer;
